import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=6fc718ec&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fc718ec')) {
      api.createRecord('6fc718ec', component.options)
    } else {
      api.reload('6fc718ec', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=6fc718ec&", function () {
      api.rerender('6fc718ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2QNWo62YYaWBl/JS/pricehelp.vue"
export default component.exports